import Http, {UrlFull} from '../Http';
import axios from 'axios';
export const findEquById = async (id, token) => {
  if (localStorage.getItem('user') && id) {
    const Headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    };
    const response = await axios.get(
      UrlFull + 'api/equ/equipo/' + id + '?conForeignIds=true',
      {headers: Headers},
    );
    return response.data;
  }
};
